import type { Canal, Servico } from '@/types'

/** free national lines, in the order a person in danger should reach for them */
export const CANAIS: Canal[] = [
    {
        id: 'policia',
        numero: '190',
        nome: "Polícia Militar",
        para: "Perigo imediato: uma agressão acontecendo agora ou a ameaça de que aconteça. Vizinhos e testemunhas também podem ligar.",
        meta: "Emergência · 24 horas · gratuito",
        tel: 'tel:190'
    },
    {
        id: 'mulher',
        numero: '180',
        nome: "Central de Atendimento à Mulher",
        para: "Orientação sobre direitos e sobre a rede de atendimento, e registro de denúncias de violência contra a mulher. Pode ser acionada pela própria mulher ou por quem sabe da situação.",
        meta: "24 horas · gratuito · sigiloso",
        tel: 'tel:180',
        whatsapp: { label: "WhatsApp (61) 9610-0180", href: 'https://wa.me/556196100180' }
    },
    {
        id: 'direitos',
        numero: '100',
        nome: "Disque Direitos Humanos",
        para: "Denúncias de violência contra crianças e adolescentes, pessoas idosas, pessoas com deficiência, população LGBTQIA+, população em situação de rua e outros grupos. A denúncia pode ser anônima.",
        meta: "24 horas · gratuito · anônimo",
        tel: 'tel:100',
        whatsapp: { label: "WhatsApp (61) 99611-0100", href: 'https://wa.me/5561996110100' }
    },
    {
        id: 'cvv',
        numero: '188',
        nome: "CVV, Centro de Valorização da Vida",
        para: "Apoio emocional e prevenção do suicídio para quem precisa conversar, a qualquer hora. Também por chat e e-mail no site do CVV.",
        meta: "24 horas · gratuito · sigiloso",
        tel: 'tel:188',
        site: { label: "cvv.org.br", href: 'https://cvv.org.br' }
    },
    {
        id: 'samu',
        numero: '192',
        nome: "SAMU",
        para: "Urgência médica: ferimentos, intoxicações, risco à vida ou crise que precise de atendimento imediato.",
        meta: "Emergência · 24 horas · gratuito",
        tel: 'tel:192'
    },
    {
        id: 'saude',
        numero: '136',
        nome: "Disque Saúde, Ouvidoria do SUS",
        para: "Informações sobre os serviços do SUS e reclamações sobre o atendimento, inclusive situações de violência institucional nos serviços de saúde.",
        meta: "Gratuito",
        tel: 'tel:136'
    }
]

export const canaisPorId = (ids: string[]): Canal[] => {
    return ids
        .map(id => CANAIS.find(canal => canal.id === id))
        .filter((canal): canal is Canal => Boolean(canal))
}

/** the shortlist shown wherever space is tight: home, footer, mobile menu */
export const SOS = [
    { numero: '190', label: "Polícia", tel: 'tel:190' },
    { numero: '180', label: "Mulher", tel: 'tel:180' },
    { numero: '100', label: "Direitos humanos", tel: 'tel:100' },
    { numero: '188', label: "CVV", tel: 'tel:188' },
    { numero: '192', label: "SAMU", tel: 'tel:192' }
]

export const REDE: Servico[] = [
    {
        nome: "Unidades de saúde",
        descricao: "UBS, UPA, hospitais e CAPS acolhem, tratam lesões e sofrimento, fazem a notificação da violência e encaminham para a rede. O atendimento não depende de boletim de ocorrência."
    },
    {
        nome: "Delegacias",
        descricao: "As Delegacias Especializadas de Atendimento à Mulher e qualquer outra delegacia registram a ocorrência e encaminham o pedido de medidas protetivas de urgência."
    },
    {
        nome: "Casa da Mulher Brasileira",
        descricao: "Reúne no mesmo lugar acolhimento, apoio psicossocial, delegacia, Defensoria, Ministério Público e Juizado, nas cidades onde existe."
    },
    {
        nome: "Centros de Referência da Mulher",
        descricao: "Oferecem acolhimento, acompanhamento psicológico e social e orientação jurídica para mulheres em situação de violência."
    },
    {
        nome: "CRAS e CREAS",
        descricao: "Os centros da assistência social apoiam famílias e acompanham pessoas em situação de violência, inclusive crianças, adolescentes e pessoas idosas."
    },
    {
        nome: "Conselho Tutelar",
        descricao: "Recebe a comunicação de suspeitas ou casos confirmados de violência contra crianças e adolescentes e aplica medidas de proteção."
    },
    {
        nome: "Defensoria Pública",
        descricao: "Orientação e defesa jurídica gratuitas: medidas protetivas, guarda, pensão, divórcio e outros direitos."
    },
    {
        nome: "Ministério Público",
        descricao: "Defende os direitos de mulheres, crianças, adolescentes, pessoas idosas e pessoas com deficiência e acompanha casos de violência."
    },
    {
        nome: "Casas-abrigo",
        descricao: "Acolhimento em endereço sigiloso para quem corre risco de morte, com acesso pela rede de atendimento."
    }
]
